<script lang="ts" setup>
	import {computed} from 'vue';
	import type {TableSort} from '@/types/table';

	const emit = defineEmits<(e: 'sort-updated', sort: TableSort) => void>();

	const props = defineProps<{
		fieldKey: string;
		fieldTranslation?: string;
		colspan?: number;
		sort: TableSort | null;
		sortable: boolean;
	}>();

	const title = computed(() => props.fieldTranslation || props.fieldKey);

	const applySort = () => {
		if (!props.sortable || !props.sort) {
			return false;
		}

		const newSort = {
			field: props.sort.field,
			direction: props.sort.direction
		};

		if (props.sort.field === props.fieldKey) {
			newSort.direction = newSort.direction === 'asc' ? 'desc' : 'asc';
		} else {
			newSort.field = props.fieldKey;
			newSort.direction = 'asc';
		}

		emit('sort-updated', newSort);
	};

</script>

<template>
	<th :colspan="colspan ?? 1"
	    :data-column="fieldKey"
	    class="js-table-header"
	    scope="col"
	    @click="applySort">

		<span>
			{{ title }}

			<template v-if="sortable">
				<template v-if="sort && sort?.field === fieldKey">
					<svg v-if="sort?.direction === 'asc'" class="icon-sort" height="10" width="6">
						<use xlink:href="/assets/images/build/svg-sprite.catalog.min.svg#sort-up"></use>
					</svg>

					<svg v-else class="icon-sort" height="10" width="6">
						<use xlink:href="/assets/images/build/svg-sprite.catalog.min.svg#sort-down"></use>
					</svg>
				</template>

				<svg v-else-if="sort" class="icon-sort" height="10" width="6">
					<use xlink:href="/assets/images/build/svg-sprite.catalog.min.svg#sort-off"></use>
				</svg>
			</template>
		</span>
	</th>
</template>
